import React from "react";
import { action, computed, makeObservable, observable } from "mobx";
import { Agreement } from "../../../models/agreements/agreement";

export class AgreementsStore {
    @observable
    private _isLoading: boolean = false;

    @observable
    private _clientAgreements: Agreement[] = [];

    constructor() {
        makeObservable(this);
    }

    private set isLoading(value: boolean) {
        this._isLoading = value;
    }

    @computed
    public get loading(): boolean {
        return this._isLoading;
    }

    @action
    public setLoading(value: boolean): void {
        this.isLoading = value;
    }

    private set clientAgreements(value: Agreement[]) {
        this._clientAgreements = value;
    }

    @computed
    public get agreements(): Agreement[] {
        return this._clientAgreements;
    }

    @action
    public setAgreements(value: Agreement[]): void {
        this.clientAgreements = value;
    }

    @action
    public editAgreement(agreement: Agreement, newValues: { [key: string]: any }): void {
        const index = this._clientAgreements.indexOf(agreement);
        if (index !== -1) {
            this._clientAgreements[index] = { ...this._clientAgreements[index], ...newValues };
        }
    }
}

export const AgreementsStoreContext = React.createContext<null | AgreementsStore>(
    null
) as React.Context<AgreementsStore>;
